import { Drawer } from '../../app/Drawer';
import { CharacterPage } from './CharacterPage';

/**
 * Building your character, with your profile behind you.
 *
 * ## Why not settings
 *
 * It lived there first and it was the wrong shelf. Settings is where you change
 * facts about your account - your email, who can message you, whether you get
 * notified. A character is not a preference, it is a thing you make, and the
 * place you make it should be the place it appears: the drawer opens from your
 * own character on your own profile, and the page behind you is where it will
 * be standing when you are done.
 *
 * Same argument the profile editor already makes for being a drawer rather than
 * a page - see `SettingsDrawer`, and the light scrim it uses for the same
 * reason.
 */
export function CharacterDrawer() {
  return (
    <Drawer title="Your character" fullPath="/character" scrim="light" width="wide">
      <CharacterPage inDrawer />
    </Drawer>
  );
}
